import React, { useEffect, useMemo, useState } from "react";
import ReactHlsPlayer from "react-hls-player";
import { useUser } from "../../context/UserContext";
import { toast } from "react-toastify";
import { Api } from "../../services/api";
import Hls from "hls.js";

import "react-toastify/dist/ReactToastify.min.css";

export default function Video() {
  return null;
}
